import { useQuery } from '@tanstack/react-query'
import { fetchDeliveryByUuid } from '../service/deliverySubscriptionService'

export const useDelivery = (uuid: string | undefined) => {
  return useQuery({
    queryKey: [{ scope: 'delivery', uuid }],
    queryFn: () => fetchDeliveryByUuid(uuid!),
    enabled: !!uuid
  })
}
